import { render } from "./imgChart.vue?vue&type=template&id=5bcd1657&scoped=true"
import script from "./imgChart.vue?vue&type=script&lang=js"
export * from "./imgChart.vue?vue&type=script&lang=js"

import "./imgChart.vue?vue&type=style&index=0&id=5bcd1657&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bcd1657"]])

export default __exports__